var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { Menu } from "@material-ui/core";
import React, { useState } from "react";
var ComponentMenu = function (_a) {
    var component = _a.component, children = _a.children;
    var _b = __read(useState(null), 2), el = _b[0], setEl = _b[1];
    return React.createElement(React.Fragment, null,
        React.createElement("div", { onClick: function (event) { return setEl(event.currentTarget); } }, component),
        React.createElement(Menu, { onClick: function () { return setEl(null); }, keepMounted: true, open: Boolean(el), anchorEl: el, getContentAnchorEl: null, onClose: function () { return setEl(null); }, anchorOrigin: {
                vertical: 'bottom',
                horizontal: 'center',
            }, transformOrigin: {
                vertical: 'top',
                horizontal: 'center',
            } }, children));
};
export default ComponentMenu;
//# sourceMappingURL=ComponentMenu.js.map